// extracted by mini-css-extract-plugin
export default {"answerContainer":"Answer_answerContainer__e405X","answerText":"Answer_answerText__A12rd","answerButton":"Answer_answerButton__A6H6S"};